var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "validation-dialog",
      attrs: {
        title: _vm.$t("CargoMsg.Cargo_FormValidation"),
        visible: _vm.visible,
        width: "600px",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "show-close": true,
        "modal-append-to-body": true,
        "append-to-body": true
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "validation-status" }, [
        _vm.hasError
          ? _c("div", { staticClass: "error-status" }, [
              _c("div", { staticClass: "status-icon error-icon" }, [
                _c("i", { staticClass: "el-icon-close" })
              ]),
              _c("span", { staticClass: "status-text" }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ValidationFailed")))
              ])
            ])
          : _c("div", { staticClass: "success-status" }, [
              _c("div", { staticClass: "status-icon success-icon" }, [
                _c("i", { staticClass: "el-icon-check" })
              ]),
              _c("span", { staticClass: "status-text" }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ValidationSucceed")))
              ])
            ])
      ]),
      _vm.hasError
        ? _c(
            "div",
            { staticClass: "error-list" },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.errorList,
                    "show-header": true,
                    border: ""
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "fieldName",
                      label: _vm.$t("CargoMsg.Cargo_Problem"),
                      width: "150"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    scope.row.isGlobalError
                                      ? ""
                                      : _vm.getFieldLabel(scope.row.fieldName)
                                  ) +
                                  " "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3385127527
                    )
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "message",
                      label: _vm.$t("CargoMsg.Cargo_Description")
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.getErrorMessage(scope.row)) +
                                  " "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1126094743
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "dialog-footer" },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [
            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Close")))
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }